import { createBrowserRouter } from 'react-router';
import RootLayout from '@/layouts/RootLayout';
import AuthRootLayout from '@/layouts/AuthRootLayout';
import { withAuth } from '@/utils/HOCs';

const noop = () => null;

const router = createBrowserRouter([
  {
    Component: withAuth(RootLayout),
    children: [
      {
        index: true,
        HydrateFallback: noop,
        async lazy() {
          const { default: Home } = await import('./Home');
          return { Component: Home };
        },
      },
      {
        path: '/events/:propertyId',
        HydrateFallback: noop,
        async lazy() {
          const { default: Events } = await import('./Events');
          return { Component: Events };
        },
      },
      {
        path: '/events/:propertyId/create',
        HydrateFallback: noop,
        async lazy() {
          const { default: CreateEvent } = await import('./CreateEvent');
          return { Component: CreateEvent };
        },
      },
      {
        path: '/events/:propertyId/:eventId',
        HydrateFallback: noop,
        async lazy() {
          const { default: Event } = await import('./Event');
          return { Component: Event };
        },
      },
      {
        path: '/members/:propertyId',
        HydrateFallback: noop,
        async lazy() {
          const { default: Members } = await import('./Members');
          return { Component: Members };
        },
      },
      {
        path: '/me',
        HydrateFallback: noop,
        async lazy() {
          const { default: UserProfile } = await import('./UserProfile');
          return { Component: UserProfile };
        },
      },
    ],
  },
  {
    Component: AuthRootLayout,
    path: '/auth',
    children: [
      {
        path: 'login',
        HydrateFallback: noop,
        async lazy() {
          const { default: Login } = await import('./Login');
          return { Component: Login };
        },
      },
      {
        path: 'forgot-password',
        HydrateFallback: noop,
        async lazy() {
          const { default: ForgotPassword } = await import('./ForgotPassword');
          return { Component: ForgotPassword };
        },
      },
      {
        path: 'reset-password',
        HydrateFallback: noop,
        async lazy() {
          const { default: ResetPassword } = await import('./ResetPassword');
          return { Component: ResetPassword };
        },
      },
      {
        path: 'invite',
        HydrateFallback: noop,
        async lazy() {
          const { default: AcceptInvite } = await import('./AcceptInvite');
          return { Component: AcceptInvite };
        },
      },
    ],
  },
  {
    path: '/feed/:eventId',
    async lazy() {
      const { default: Feed } = await import('./Feed');
      return { Component: Feed };
    },
  },
]);

export default router;
